import { useState, useEffect } from "react";

export default function SubVariantPriceInput({ variantUiId, comboList, setComboList }) {
  const original = comboList.find((c) => c.variantUiId === variantUiId);
  const displayValue = typeof original?.price === "number" ? original.price.toFixed(2) : "";

  const [tempValue, setTempValue] = useState(displayValue);

//   Put commas where necessary
  const formatWithCommas = (value) => {
    const [intPart, decimalPart] = value.split(".");
    const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decimalPart ? `${formatted}.${decimalPart}` : formatted;
  };

  // Sync input when comboList updates externally
  useEffect(() => {
    const latest = comboList.find((c) => c.variantUiId === variantUiId);
    const val = typeof latest?.price === "number"
        ? formatWithCommas(latest.price.toFixed(2))
        : "";

    setTempValue(val);
  }, [comboList, variantUiId]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");

    const parts = raw.split(".");
    const cleaned = parts[0] + (parts[1] ? "." + parts[1].slice(0, 2) : "");

    setTempValue(cleaned);
  };

  const handleBlur = () => {
    const floatVal = parseFloat(tempValue.replace(/,/g, ""));
    if (isNaN(floatVal)) return;

    const updated = comboList.map((c) =>
      c.variantUiId === variantUiId
        ? {
            ...c,
            price: floatVal,
            meta: { ...(c.meta || {}), priceDirty: true },
          }
        : c
    );

    setComboList(updated);
    setTempValue(floatVal.toFixed(2));
  };

  return (
    <div className="relative flex-1 max-w-[10em]" onClick={(e) => e.stopPropagation()}>
      <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[14px] font-medium text-[#333]">
        KES
      </span>
      <input
        type="text"
        inputMode="decimal"
        value={tempValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="0.00"
        className=" pl-[3em] border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] font-medium"
      />
    </div> 
  );
};
